import { SORT_DIRECTION_MAP_TO_PRESENTATION } from './sort-direction';

/* eslint-disable @typescript-eslint/naming-convention -- Names must match enum names, which are PascalCase */
/** Display information for an enum value. */
export const enumDisplayConfig = {
  SortDirection: SORT_DIRECTION_MAP_TO_PRESENTATION,
} as const;
/* eslint-enable @typescript-eslint/naming-convention */

/** Enum names that have display information. */
export type DisplayedEnum = keyof typeof enumDisplayConfig;

/** Keys of the presentation map for a given enum. */
export type PresentationMapKey<DEnum extends DisplayedEnum> = keyof (typeof enumDisplayConfig)[DEnum];

/** Values of the presentation for a given enum key. */
export type PresentationValue<DEnum extends DisplayedEnum, PMKey extends PresentationMapKey<DEnum>> =
  (typeof enumDisplayConfig)[DEnum][PMKey];
